import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'

function Hepatitis(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-03-hepatitis-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Hepatitis"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Hepatitis is <b>inflammation of the liver. </b>Inflammation is swelling that happens when tissues of the
                                    body are injured or infected. It can damage your liver. This swelling and damage can affect how well
                                    your liver functions. Hepatitis can be an acute (short-term) infection or a chronic (long-term)
                                    infection.
                                </p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Hepatitis/Bitmap-(1).png")} alt="hepatitis" />
                                    </div>
                                </div>
                                <p>
                                    <b>Hepatitis A</b>
                                </p>
                                <p>
                                    Hepatitis A is the result of an infection with the hepatitis A virus
                                    (HAV). This type of hepatitis is an acute, short-term disease.
                                </p>
                                <p>
                                    <b>Hepatitis B</b>
                                </p>
                                <p>
                                    The hepatitis B virus (HBV) causes hepatitis B. This is often an
                                    ongoing, chronic condition. The Centers for Disease Control and
                                    Prevention (CDC) estimates that around 826,000Trusted Source people
                                    are living with chronic hepatitis B in the United States and around
                                    257 million people worldwide.
                                </p>
                                <p>
                                    <b>Hepatitis C</b>
                                </p>
                                <p>
                                    Hepatitis C comes from the hepatitis C virus (HCV). HCV is among the
                                    most common bloodborne viral infections in the United States and
                                    typically presents as a long-term condition.
                                </p>
                                <p>
                                    According to the CDC, approximately 2.4 million AmericansTrusted
                                    Source are currently living with a chronic form of this infection.
                                </p>
                                <p>
                                    <b>Hepatitis D</b>
                                </p>
                                <p>
                                    This is a rare form of hepatitis that only occurs in conjunction
                                    with hepatitis B infection. The hepatitis D virus (HDV) causes liver
                                    inflammation like other strains, but a person cannot contract HDV
                                    without an existing hepatitis B infection.
                                </p>
                                <p>
                                    Globally, HDV affects almost 5 percentTrusted Source of people with
                                    chronic hepatitis B.
                                </p>
                                <p>
                                    <b>Hepatitis E</b>
                                </p>
                                <p>
                                    Hepatitis E is a waterborne disease that results from exposure to
                                    the hepatitis E virus (HEV). Hepatitis E is mainly found in areas
                                    with poor sanitation and typically results from ingesting fecal
                                    matter that contaminates the water supply.
                                </p>
                                <p>
                                    This disease is uncommonTrusted Source in the United States,
                                    according to the CDC.
                                </p>
                                <p>
                                    Hepatitis E is usually acute but can be particularly dangerous in
                                    pregnant women.
                                </p>
                                
                               
                                <p>
                                    <b>Symptoms</b>
                                </p>
                                <ul className="listUnstyle">
                                    <li><a className='links' href='https://medlineplus.gov/fever.html'>Fever</a></li>
                                    <li><a className='links' href='https://medlineplus.gov/fatigue.html'>Fatigue</a></li>
                                    <li>Loss of appetite</li>
                                    <li><a className='links' href='https://medlineplus.gov/nauseaandvomiting.html'>Nausea and/or vomiting eyes </a></li>
                                    <li><a className='links' href='https://medlineplus.gov/nauseaandvomiting.html'>Abdominal pain</a></li>
                                    <li>Dark urine</li>
                                    <li>Clay-colored bowel movements</li>
                                    <li>Joint pain</li>
                                    <li><a className='links' href='https://medlineplus.gov/jaundice.html'>Jaundice</a>, yellowing of your skin and eyes</li>
                                </ul>
                                {/* <p>
                                    <b>Hepatitis treatment</b>
                                </p>
                                <p>
                                    <b>Hepatitis B</b> - A serious liver infection caused by the
                                    hepatitis B virus that's easily preventable by a vaccine.
                                </p>
                                <p>
                                    <b>Hepatitis C</b> - An infection caused by a virus that attacks the
                                    liver and leads to inflammation.
                                </p>
                                <p>
                                    <b>Alcoholic hepatitis</b> - Liver inflammation caused by drinking
                                    too much alcohol.
                                </p>
                                <p>
                                    <b>Autoimmune hepatitis</b> - Inflammation in the liver that occurs
                                    when the immune system attacks the liver.
                                </p>
                                <p>
                                    <b>Hepatitis D</b> - A serious liver disease caused by infection
                                    with the hepatitis D virus.
                                </p>
                                <p>
                                    <b>Hepatitis A</b> - A highly contagious liver infection caused by
                                    the hepatitis A virus.
                                </p>
                                <p>
                                    <b>Hepatitis E</b> - A liver disease caused by the hepatitis E
                                    virus.
                                </p> */}
                                <a className="links" href="https://en.wikipedia.org/wiki/Hepatitis">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Hepatitis;